import React from "react";
import { renderToString } from "react-dom/server";
import { format } from "date-fns";
import Highcharts from "highcharts";
import { Theme } from "@mui/material";
import { ChartTooltip } from "@components/Tooltip/ChartTooltip";
import { splitFormatter } from "@components/Tooltip/chartSplitFormatter";

export const formatDate = (value?: string | number) => {
  if (!value) return "";

  return `${format(new Date(value), "dd. MMM ")}'${format(
    new Date(value),
    "yy"
  )}`;
};

type Props = {
  theme?: Theme;
  formatter: (value?: string | number | null) => React.ReactNode;
  x?: string | number;
  points?: Highcharts.TooltipFormatterContextObject[];
  dateFormatter?: (value?: string | number) => string;
};

export const PerformanceValuationTooltip = ({
  theme,
  x,
  points,
  formatter,
  dateFormatter = formatDate,
}: Props) => {
  const arr =
    points?.map((item) => splitFormatter({ formatter, point: item, theme })) ||
    [];

  if (!theme) return null;

  return [
    renderToString(
      <ChartTooltip theme={theme}>
        <div
          style={{
            fontSize: theme?.typography.caption.fontSize,
            fontWeight: 500,
            color: theme.palette.text.onTooltipPrimary,
          }}
        >
          {dateFormatter(x)}
        </div>
      </ChartTooltip>
    ),
    ...arr,
  ];
};
